import { FormControl } from "@angular/forms";

export const phoneRegex = /^911|([\s\b\B\w-+(]{0,2}[0-9][\s\b\B\w-0)]{0,2}){10,13}$/; // NOSONAR
export const phoneValid = (control: FormControl) => {
    const value = control?.value || "";
    if (!value) {
        return null;
    }

    const errors: Record<string, string> = {};
    const stringVal = value.toString();
    const numLength = stringVal.replace(/[^\d]/g, "").length;

    if (value === "911") {
        return null;
    }

    if (!phoneRegex.test(value) || numLength > 13) {
        errors.phoneValid = `Please enter a valid phone number`;
    }

    if (numLength < 10) {
        errors.minlength = `Please enter a complete phone number`;
    }

    return Object.values(errors).some(val => !!val) ? errors : null;
};

export const usPhoneValid = (control: FormControl) => {
    const value = control?.value || "";
    if (!value || value === "911") {
        return null;
    }

    const errors: Record<string, string> = {};
    if (!phoneRegex.test(value) || value.replace(/[^\d]/g, "").length > 10) {
        errors.usPhoneValid = `Please enter a valid phone number`;
    }

    return Object.values(errors).some(val => !!val) ? errors : null;
};
